"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCKED_SUBSCRIPTION_SETTINGS_FIELDS = exports.isOpenSubscriptionStatus = exports.OPEN_SUBSCRIPTION_STATUSES = exports.isSubscriptionIntakeOpen = exports.isSubscriptionSettingsComplete = exports.getMissingSubscriptionSettingsFields = exports.SUBSCRIPTION_SETTINGS_FIELD_LABELS = exports.MAX_CUSTOM_DEALING_DATES = void 0;
const IRedemptionConfig_1 = require("./IRedemptionConfig");
Object.defineProperty(exports, "MAX_CUSTOM_DEALING_DATES", { enumerable: true, get: function () { return IRedemptionConfig_1.MAX_CUSTOM_DEALING_DATES; } });
const enums_1 = require("./enums");
exports.SUBSCRIPTION_SETTINGS_FIELD_LABELS = {
    allowSubscriptions: "Allow investors to subscribe",
    dealingFrequency: "Dealing frequency",
    customDealingDates: "Custom dealing dates",
    cutoff: "End of day",
    minimumSubscriptionUnits: "Minimum subscription units",
    maximumSubscriptionUnits: "Maximum subscription units",
    roundingMethod: "Rounding method",
};
const dealingFrequencyValues = new Set(Object.values(enums_1.DealingFrequency));
const roundingMethodValues = new Set(Object.values(enums_1.RoundingMethod));
const isInSet = (values, value) => Boolean(value?.trim() && values.has(value.trim()));
// A zero ceiling, or one below the floor, leaves nothing an investor could apply for.
const isUsableVolumeCeiling = (config) => {
    const maximum = config?.maximumSubscriptionUnits;
    const minimum = config?.minimumSubscriptionUnits;
    if (!(0, IRedemptionConfig_1.isNonNegativeInteger)(maximum) || maximum === 0) {
        return false;
    }
    return !(0, IRedemptionConfig_1.isNonNegativeInteger)(minimum) || maximum >= minimum;
};
// `allowSubscriptions` is excluded: settings can be complete while subscriptions are switched off.
const getMissingSubscriptionSettingsFields = (config) => {
    const missing = [];
    if (!isInSet(dealingFrequencyValues, config?.dealingFrequency)) {
        missing.push(exports.SUBSCRIPTION_SETTINGS_FIELD_LABELS.dealingFrequency);
    }
    if (!(0, IRedemptionConfig_1.areValidCustomDealingDates)(config)) {
        missing.push(exports.SUBSCRIPTION_SETTINGS_FIELD_LABELS.customDealingDates);
    }
    if (!(0, IRedemptionConfig_1.isValidDealingCutoff)(config?.cutoff)) {
        missing.push(exports.SUBSCRIPTION_SETTINGS_FIELD_LABELS.cutoff);
    }
    if (!(0, IRedemptionConfig_1.isNonNegativeInteger)(config?.minimumSubscriptionUnits)) {
        missing.push(exports.SUBSCRIPTION_SETTINGS_FIELD_LABELS.minimumSubscriptionUnits);
    }
    if (!isUsableVolumeCeiling(config)) {
        missing.push(exports.SUBSCRIPTION_SETTINGS_FIELD_LABELS.maximumSubscriptionUnits);
    }
    if (!isInSet(roundingMethodValues, config?.roundingMethod)) {
        missing.push(exports.SUBSCRIPTION_SETTINGS_FIELD_LABELS.roundingMethod);
    }
    return missing;
};
exports.getMissingSubscriptionSettingsFields = getMissingSubscriptionSettingsFields;
const isSubscriptionSettingsComplete = (config) => (0, exports.getMissingSubscriptionSettingsFields)(config).length === 0;
exports.isSubscriptionSettingsComplete = isSubscriptionSettingsComplete;
const isSubscriptionIntakeOpen = (config) => config?.allowSubscriptions === true && (0, exports.isSubscriptionSettingsComplete)(config);
exports.isSubscriptionIntakeOpen = isSubscriptionIntakeOpen;
/** Applications booked into a window but not yet priced. The partial unique index keys on this pair. */
exports.OPEN_SUBSCRIPTION_STATUSES = ["applicationReceived", "approvedInPrinciple"];
const isOpenSubscriptionStatus = (status) => exports.OPEN_SUBSCRIPTION_STATUSES.includes(status);
exports.isOpenSubscriptionStatus = isOpenSubscriptionStatus;
/**
 * Frozen while the fund holds an open application. `allowSubscriptions` is absent deliberately — it is
 * how the admin stops new applications so the queue can drain and the lock can release.
 */
exports.LOCKED_SUBSCRIPTION_SETTINGS_FIELDS = [
    "dealingFrequency",
    "customDealingDates",
    "cutoff",
    "minimumSubscriptionUnits",
    "maximumSubscriptionUnits",
    "roundingMethod",
];
//# sourceMappingURL=ISubscriptionConfig.js.map